import React, { useState, useEffect, useCallback } from 'react';
import appController, { Status } from '@app/App.Controller'
import { Panel, Stat, Layout, LazyBoi, Amount, GateKeeper, Field } from '@components'
import styled from 'styled-components'
import { Asset } from "@archetypes"
import { RedeemController } from './_controller'

const RedeemPanel = styled(
    ({ className, setExtensions, address }) => {

        const [option, setOption] = useState()

        const [params, setParams] = useState()

        useEffect(() => {
            const redeemController = new RedeemController(address, appController)
            redeemController.on('params', setParams)
            redeemController.init()
            return () => redeemController.cleanup()
        }, [address]) // eslint-disable-line

        useEffect(() => {
            setExtensions([])
        },[option])

        const onSelect = useCallback((val) => {
            if (option === val) {
                setOption()
            } else {
                setOption(val)
            }
        }, [option])

        return (
            <>
                <Panel>
                    <Field.RadioGroupBordered
                        value={option}
                        options={[
                            {
                                label: 'Partial redeem assets',
                                sublabel: "Redeem a portion of assets while maintaining position on asset",
                                value: 1,
                                disabled: !params?.canRedeemPartial || params?.myPosition?.expired
                            },
                            {
                                label: 'Fully redeem assets',
                                sublabel: "Redeem all assets and exit your position",
                                value: 2,
                                disabled: !params?.canRedeemFull
                            }
                        ]}
                        onChange={val => onSelect(val)}
                    />
                </Panel>
                {option === 1 && (<Asset.RedeemPartial address={address} setExtensions={setExtensions} />)}
                {option === 2 && (<Asset.RedeemAll.Panel address={address} setExtensions={setExtensions} />)}
               
            </>
        )
    })`

    `

export default RedeemPanel